import Logo from "Utils/Assets/Images/Logo.png";
import SysLogo from "./components/Logo";
import MenuSmall from "./components/MenuSmall";
import MenuDrawer from "./components/MenuDrawer";
import IButton from "Screens/components/iButton";
import * as Icons from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

export default function Menu() {
  const { t } = useTranslation();

  return (
    <div className="menu-items">
      <SysLogo image={Logo} alt="tamima" md />
      <MenuSmall />
      <MenuDrawer />
      {/* <button className="btn-connect-wallet">
        <Icons.Wallet />
        <span>
          {"Connect Wallet"}
        </span>
      </button> */}
    </div>
  );
}
